import { Injectable } from '@angular/core';
import { MobileEventsService as BaseMobileEventsService } from '@outlaw/core';
import { CommunityItem, MobileEvents, PostUser } from '../../interfaces';
import {
  MobileVideoEventData,
  MobileProfileEventData,
  FlixsnipVideoEventData,
} from '../../interfaces/mobile-events.interface';

@Injectable({ providedIn: 'root' })
export class CommunityMobileEventsService extends BaseMobileEventsService {
  loadComplete(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.loadComplete);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().loadComplete();
    }
  }

  openEpisode(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openEpisode, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openEpisode(id);
    }
  }

  openUserProfile(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openUserProfile, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openUserProfile(id);
    }
  }

  openStarProfile(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openStarProfile, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openStarProfile(id);
    }
  }

  openShowDetails(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openShowDetails, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openShowDetails(id);
    }
  }

  openVideo({ token, title }: MobileVideoEventData): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openVideo, { token, title });
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openVideo(token, title);
    }
  }

  openPlayer({ token, title }: MobileVideoEventData): void {
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openPlayer(token, title);
    }

    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openPlayer, { token, title });
    }
  }

  openPlaylist(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openPlaylist, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openPlaylist(id);
    }
  }

  openFilmmaker(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openFilmmaker, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openFilmmaker(id);
    }
  }

  openChannel(id: number): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openChannel, id);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openChannel(id);
    }
  }

  openRecommendedUsersByPost({ postId, postOwner }: { postId: string; postOwner: PostUser | null }): void {
    const data = { postId, postOwner };

    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openRecommendedUsersByPost, data);
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openRecommendedUsersByPost(data);
    }
  }

  openUrl(link: string): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openUrl, link);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openUrl(link);
    }
  }

  openAuth(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openAuth);
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openAuth();
    }
  }

  openSubscribe(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openSubscribe);
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openSubscribe();
    }
  }

  openProfilePage({ username, userUuid }: MobileProfileEventData): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openProfilePage, { username, userUuid });
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openProfilePage(username, userUuid);
    }
  }

  openPost(postId: string): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openPost, postId);
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openPost(postId);
    }
  }

  sendPostDetails(post: CommunityItem): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.postDetails, post);
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().sendPostDetails(post);
    }
  }

  openFlixsnipVideo({ videoLink, id, type }: FlixsnipVideoEventData): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.openFlixsnipVideo, {
        videoLink,
        id,
        type,
      });
    }

    if (this.isAndroidWebView) {
      this.sendAndroidEvent().openFlixsnipVideo(videoLink, id, type);
    }
  }

  emptyPosts(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.emptyPosts);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().emptyPosts();
    }
  }

  goBack(): void {
    if (this.isIosWebView) {
      this.sendIosEvent(MobileEvents.goBack);
    }
    if (this.isAndroidWebView) {
      this.sendAndroidEvent().goBack();
    }
  }
}
